export const formatStoryType = (urn = '') => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_surn, _xing, namespace = '', table = ''] = urn.split(':');
    return `${namespace}:${table}`;
};
//# sourceMappingURL=format-story-type.js.map